import { Collapse, CollapseProps, Flex } from 'antd';
import dayjs from 'dayjs';
import { FC, ReactNode } from 'react';
import { StagesStore } from '../../../../DataSource/Stores/Cabinet/StagesStore';
import * as styles from './index.module.scss';

interface IProps {
  expandIcon: (panelProps: any) => ReactNode;
}

const SystemTasksBlock: FC<IProps> = ({ expandIcon }) => {
  const systemTasksCollapseItems: CollapseProps['items'] = [
    {
      key: '1',
      label: 'СИСТЕМНЫЕ ЗАДАЧИ',
      children: (
        <Flex vertical gap={8}>
          {StagesStore.dataSystemTask.map((task) => (
            <div key={task._id} className={styles.field}>
              <p className={styles.label}>
                #{task._id.slice(-4)}: {task.status}
              </p>
              {dayjs(task.updatedAt).format('DD / MM / YYYY, HH:mm:ss')}
            </div>
          ))}
        </Flex>
      ),
    },
  ];

  return (
    <Collapse
      items={systemTasksCollapseItems}
      expandIcon={expandIcon}
      expandIconPosition="right"
      bordered={false}
      defaultActiveKey={[1]}
      ghost
    />
  );
};

export default SystemTasksBlock;
